import _ from 'lodash';
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

function customizer(objValue:any, srcValue:any) {
  if (_.isArray(objValue)) {
    return srcValue;
  }
}

interface IndexByAny {
  [key: string]: any,
};

const initialState:IndexByAny = {
};

/**
 * Slice for controlling Storage
 */
const storageSlice = createSlice({
  name: 'storage',
  initialState,
  reducers: {
    setInStorage: (state, action:PayloadAction<any>) => {
      let res = _.cloneDeep(state);
      res = _.mergeWith(res, action.payload, customizer);
      return res;
    },
    removeFromStorage: (state, action:PayloadAction<string>) => {
      return _.omit(state, [action.payload]);
    },
    clearStorage: () => initialState,
  }
});

export default storageSlice.reducer;

export const { setInStorage, removeFromStorage, clearStorage } = storageSlice.actions;
